import { useEffect, useState } from "react";
import { toAbsoluteUrl } from "../helpers"
import { useAuth } from "../utils/Auth";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Pusher from "pusher-js";
import { ShowRequestApprove } from "../store/LmsAction";
import { pusherConfig } from "../config/pusherConfig";
import { logout } from "../store/AuthCRUD";

const NavbarLms = () => {
  const {appKey, channelName, eventName, cluster, enabledTransports} = pusherConfig('lms')
  const { user, onLogout }:any = useAuth();
  const company_id:any = user?.base_perusahaan_id
  const location = useLocation();
  const navigate = useNavigate();
  // const showMenu = user?.unit_pegawai === 'INFORMATION TECHNOLOGY' || user?.sub_unit_pegawai === 'EDUTRACE & TRAINING DEVELOPMENT'

  const [formDisabled, setFormDisabled] = useState<boolean>(false);
  const [menuActive, setMenuActive] = useState<string>('');
  const [dataApproval, setDataApproval] = useState<any>([]);
  const [statusApproval, setStatusApproval] = useState<boolean>(false);
  const [count, setCount] = useState<number>(0)

  const showRequestApprove = (data:any) => {
    setStatusApproval(false)
    ShowRequestApprove({company_id})
      .then((res:any) => {
        const dt = res.data.data
        // console.log(dt)
        setDataApproval(dt)
        setStatusApproval(true)
        setCount(dt.length)
        // toast.info(data?.pesan, {position: 'top-right'});
      })
      .catch((err:any) => {
        console.log(err)
      })
      // .finally(() => {
      //   setLoadingCount(false)
      // })
  }

  // Connect pusher notification approval
  useEffect(() => {
    const pusher = new Pusher(appKey, { cluster, enabledTransports });
    const channel = pusher.subscribe(channelName);
    channel.bind(eventName, (data:any) => {
      // console.log(data)
      if (data.receiver === user.id) showRequestApprove(data);
    });
    return () => {
      pusher.unsubscribe(channelName);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      showRequestApprove({})
    }
    return () => {isMounted = false}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = () => {
    setFormDisabled(true)
    logout({})
      .then(() => {
        toast.success('Logout Sukses !', {position: 'top-right'});
      })
      .catch((err:any) => console.log(err) )
      .finally(() => {
        setFormDisabled(false)
        onLogout()
      });
  }

  useEffect(() => {
    const arr_path = location.pathname.split('/')
    setMenuActive(arr_path[2])
  }, [location.pathname, menuActive])

  const routeToApproval = (url:string, dt:any, stat:boolean) => {
    navigate(url, {state: {data: dt, status_data: stat}})
  }

  return (
    <div className="w-100" style={{position: 'fixed', zIndex: 3, top: 0}}>
      <nav className="navbar navbar-expand-lg bg-light p-0 m-0 border-bottom border-2">
        <div className="container-fluid ps-0">
          <Link className="navbar-brand py-0 me-0 w-auto" to='/lms/my-courses' style={{maxWidth: '70%'}}>
            <img
              alt='header-img'
              // className='h-60px logo'
              src={window.innerWidth > 430 ? toAbsoluteUrl('/media/images/logo3-new.png') : toAbsoluteUrl('/media/images/logo4.png')}
            />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <div className="me-auto"></div>
            <ul className="navbar-nav mb-2 mb-lg-0 ms-auto">
              <li className="nav-item mx-2 d-flex">
                <Link className='nav-link' to='/profil'>
                  <span data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02"><span className="fa fa-arrow-left"/> PHC Kece</span>
                </Link>
              </li>
              {/* <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${menuActive === 'dashboard' && 'active'}`} to='/lms/dashboard'>
                  <span>Dashboard</span>
                </Link>
              </li> */}
              <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${(menuActive === 'courses' || menuActive === 'course') && 'active'}`} to='/lms/courses'>
                  <span data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02">Courses</span>
                </Link>
              </li>
              <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${menuActive === 'manage-courses' && 'active'}`} to='/lms/manage-courses'>
                  <span data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02">Manage Courses</span>
                </Link>
              </li>
              <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${menuActive === 'my-courses' && 'active'}`} to='/lms/my-courses'>
                  <span data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02">My Courses</span>
                </Link>
              </li>
              {/* {showMenu &&
                <li className="nav-item mx-2 d-flex">
                  <Link className={`nav-link ${menuActive === 'report' && 'active'}`} to='/lms/report'>
                    <span>Report</span>
                  </Link>
                </li>
              } */}
              <li className="nav-item mx-2 d-flex">
                <div className={`nav-link-div nav-link ${menuActive === 'approval' && 'active'}`} onClick={() => routeToApproval('lms/approval', dataApproval, statusApproval)}>
                  <span data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo02">Approval</span>
                </div>
                {count > 0 &&
                  <div style={{position: 'relative', marginLeft: '-4px'}}>
                    <span className='w-auto rounded-circle bg-danger text-center px-1 py-1' style={{fontSize: '10px'}}>
                      <span className='d-inline-block' style={{color: 'white', minWidth: '14px'}}>
                        {count}
                      </span>
                    </span>
                  </div>
                }
              </li>
              <li className="nav-item mx-2 d-flex">
                <span className="nav-link dropdown-toggle" id="dropdownMenuClickableInside" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{color: '#9d9d9d'}}>
                  Akun
                </span>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuClickableInside">
                  <li>
                    <button type="button" disabled={formDisabled} className="dropdown-item btn btn-link" onClick={handleLogout}>
                      {formDisabled && <i className="fas fa-spinner fa-pulse"></i>} Logout
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <nav className="navbar navbar-expand-lg bg-light p-0 m-0 border-bottom border-2">
        <div className="container-fluid ps-0">
          <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
            <div className="me-auto"></div>
            <ul className="navbar-nav mb-2 mb-lg-0 ms-auto">
              <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${menuActive === 'dashboard' && 'active'}`} to='/lms/dashboard'>
                  <span>Dashboard</span>
                </Link>
              </li>
              <li className="nav-item mx-2 d-flex">
                <Link className={`nav-link ${menuActive === 'courses' && 'active'}`} to='/lms/courses'>
                  <span>Courses</span>
                </Link>
              </li>
              <li className="nav-item mx-2 d-flex">
                <span className="nav-link dropdown-toggle" id="dropdownMenuClickableInside" role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{color: '#9d9d9d'}}>
                  Akun
                </span>
                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuClickableInside">
                  <li>
                    <button type="button" disabled={formDisabled} className="dropdown-item btn btn-link" onClick={handleLogout}>
                      {formDisabled && <i className="fas fa-spinner fa-pulse"></i>} Logout
                    </button>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav> */}
    </div>
  )
}

export {NavbarLms}
